import React, { useState } from "react";
import { Box, Tabs, Tab, Typography, Divider } from "@mui/material";
import HccCategories from "components/hccCategories";
import DialCodeMapping from "components/diagCodeMapping";
import RiskScore from "components/riskScore";

const RiskAdjustment = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box width="100%" bgcolor="white">
      <Typography variant="h6" gutterBottom m={2}>
        Risk Adjustment Modeling
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <Tabs
        value={tabIndex}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 2 }}
      >
        <Tab label="HCC Categories" />
        <Tab label="HCC Category Diag Code Mapping" />
        <Tab label="Risk Score Calculator" />
      </Tabs>

      {/* Tab Content */}
      <Box>
        {tabIndex === 0 && <HccCategories />}
        {tabIndex === 1 && <DialCodeMapping />}
        {tabIndex === 2 && <RiskScore />}
      </Box>
    </Box>
  );
};

export default RiskAdjustment;
